module.exports = __webpack_public_path__ + "assets/pre_zh.c1ac9d26132779867218155cd6dec6f1.png";